import { useQuery } from "@tanstack/react-query";
import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

interface Props {
  queryKey?: string;

  InicioIntervaloCadastroCampanha: string;
  FimIntervaloCadastroCampanha: string;
}
export function useGetGerarRelatorio(props: Props) {
  const hasInicioIntervaloCadastroCampanha =
    props.InicioIntervaloCadastroCampanha
      ? `InicioIntervaloCadastroCampanha=${props.InicioIntervaloCadastroCampanha}`
      : "";
  const hasFimIntervaloCadastroCampanha = props.FimIntervaloCadastroCampanha
    ? `&FimIntervaloCadastroCampanha=${props.FimIntervaloCadastroCampanha}`
    : "";
  const fetchData = async () => {
    const GERAR_RELATORIO = `${leadsWebEnviroment}/common/campanha/exportar-campanhas/v1?${hasInicioIntervaloCadastroCampanha}${hasFimIntervaloCadastroCampanha}`;
    const response = await instance.get(GERAR_RELATORIO);
    return response?.data?.data;
  };

  const query = useQuery({
    enabled: false, // Só executa quando chamado via refetch
    queryFn: fetchData,
    queryKey: [props.queryKey || "gerar_relatorio"],
    refetchOnWindowFocus: false,
  });

  return query;
}
